import { BookingCheckout } from '@drycut/booking-components';
import { FatalErrorWithStack } from '@drycut/ui-components';
import { ErrorBoundary } from '@rollbar/react';

export function IframeCheckout(): React.ReactElement {
  return (
    <ErrorBoundary fallbackUI={FatalErrorWithStack}>
      <BookingCheckout hideIntroText hidePassBadge />
    </ErrorBoundary>
  );
}
